import { apiService } from './api';
import {
  FacilityTemplate,
  FacilityTemplateCreate,
  FacilityTemplateUpdate,
} from '../types';

export class TemplatesService {
  async list(): Promise<FacilityTemplate[]> {
    return apiService.get<FacilityTemplate[]>('/facility-templates/');
  }

  async getById(id: string): Promise<FacilityTemplate> {
    return apiService.get<FacilityTemplate>(`/facility-templates/${id}`);
  }

  async create(payload: FacilityTemplateCreate): Promise<FacilityTemplate> {
    return apiService.post<FacilityTemplate>('/facility-templates/', payload);
  }

  async update(id: string, payload: FacilityTemplateUpdate): Promise<FacilityTemplate> {
    return apiService.put<FacilityTemplate>(`/facility-templates/${id}`, payload);
  }

  async delete(id: string): Promise<void> {
    return apiService.delete<void>(`/facility-templates/${id}`);
  }
}

export const templatesService = new TemplatesService();
